module.exports = __webpack_public_path__ + "static/img/slide1.0d2736c5.jpg";